import { useLinked, useModel } from "@type-r/react";
import React from "react";
import { InvoiceData } from "../../api/invoiceChange";
import { AssetsSection } from "../assets-section";
import { InblockedAssetsDataStep } from "../inblocked-assets-data-step";
import { InblockedAssetsTitle } from "../inblocked-assets-title";
import { InvoiceExternalSystems } from "./externalSystems";
import { InvoiceTile } from "./invoice-tile";

export const InblockedInvoicesDataStep = ({ job, back, $assetTypeSelect, assetTypeMultiOptions, $refreshEvents, height }: { job, back?, $assetTypeSelect?, assetTypeMultiOptions?, $refreshEvents?, height?}) => {
    const invoiceChanges = useModel(InvoiceData);
    const selectedInvoices = useModel(InvoiceData);
    const $activeInvoice = useLinked(null);
    const $filter = useLinked({ search: '', eventType: null });
    const $loadedAssetEvents = useLinked(false);

    const $selectAllAssets = useLinked(false);

    return <InblockedAssetsDataStep
        assetName='Invoice'
        assetChanges={invoiceChanges}
        selectedAssets={selectedInvoices}
        $filter={$filter}
        job={job}
        back={back}
        $loadedAssetEvents={$loadedAssetEvents}
        assetsListComponent={
            (filteredAssetChanges, itemsCount, $selectAllAssets, assetEventsGeneralCount) =>
                <AssetsSection
                    height={height ? height : 420}
                    // this is the tiles that show grouped success/failure
                    title={<InblockedAssetsTitle assetChanges={invoiceChanges.items} externalSystems={InvoiceExternalSystems} $filter={$filter} $loadedAssetEvents={$loadedAssetEvents} importJobId={job.importJobId} itemsCount={itemsCount} assetEventsGeneralCount={assetEventsGeneralCount} />}
                    assets={filteredAssetChanges}
                    assetTile={InvoiceTile}
                    notExpanded={false}
                    $active={$activeInvoice}
                    selected={selectedInvoices.items}
                    selectAllAssets={$selectAllAssets} />
        }
        externalSystems={InvoiceExternalSystems}
        $assetTypeSelect={$assetTypeSelect}
        assetTypeMultiOptions={assetTypeMultiOptions}
        $refreshEvents={$refreshEvents}
        selectAllAssets={$selectAllAssets} />
};
